// =====================================================================
// FDI tooth maps + Permanent / Both / Primary mode helpers.
// =====================================================================

export const PERMANENT_UPPER = [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28];
export const PERMANENT_LOWER = [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38];
export const PRIMARY_UPPER   = [55,54,53,52,51,61,62,63,64,65];
export const PRIMARY_LOWER   = [85,84,83,82,81,71,72,73,74,75];

export function isPrimary(fdi) {
  const n = Number(fdi);
  const q = Math.floor(n / 10);
  return q >= 5 && q <= 8;
}

// Default mode driven by patient DOB.
//   under 6 → primary, 6–12 → both, 12+ → permanent.
export function defaultDentitionFromDOB(dobIso) {
  if (!dobIso) return "permanent";
  const dob = new Date(dobIso);
  if (Number.isNaN(dob.getTime())) return "permanent";
  const ageYrs = (Date.now() - dob.getTime()) / (365.25 * 24 * 60 * 60 * 1000);
  if (ageYrs < 6)  return "primary";
  if (ageYrs < 12) return "both";
  return "permanent";
}

// Returns the FDI numbers to render for one arch / dentition.
//
// `dentition` is 'permanent' or 'primary' — the kind of teeth in the row.
// `side` filters the row to one half of the mouth:
//   'right' → patient's right (visual left): Q1 / Q4 / Q5 / Q8
//   'left'  → patient's left  (visual right): Q2 / Q3 / Q6 / Q7
//   undefined / 'both' → full arch
export function archFdiList(arch, dentition, side = "both") {
  const perm    = arch === "upper" ? PERMANENT_UPPER : PERMANENT_LOWER;
  const primary = arch === "upper" ? PRIMARY_UPPER   : PRIMARY_LOWER;
  const row = dentition === "primary" ? primary : perm;
  if (side === "right") return row.filter((fdi) => sideForFdi(fdi) === "right");
  if (side === "left")  return row.filter((fdi) => sideForFdi(fdi) === "left");
  return row;
}

// Returns 'right' (patient's right = viewer's left) or 'left'.
// FDI quadrants: 1, 4 = right (perm); 5, 8 = right (primary); 2, 3, 6, 7 = left.
export function sideForFdi(fdi) {
  if (fdi == null) return "right";
  const q = Math.floor(Number(fdi) / 10);
  return (q === 1 || q === 4 || q === 5 || q === 8) ? "right" : "left";
}
